import { useCompanyStore } from '@/stores/company';

export const updateUserDetails = (formData: any, saveUserDetails: boolean) => {
  // Add timeout to prevent this from blocking the event event loop
  setTimeout(() => {
    if (localStorage && typeof localStorage === 'object') {
      if (saveUserDetails) {
        const { company } = useCompanyStore();

        const objForStorage = Object.assign({}, formData);
        objForStorage.companyId = company.id;
        objForStorage.notes = undefined;
        objForStorage.discountCode = undefined;
        try {
          localStorage.setItem(
            'bookingUserDetails',
            JSON.stringify(objForStorage)
          );
        } catch {
          console.warn('Localstorage unavailable.');
        }

        window.parent.postMessage(
          {
            userDetails: JSON.stringify(objForStorage)
          },
          '*'
        );
      } else {
        try {
          localStorage.removeItem('bookingUserDetails');

          window.parent.postMessage(
            {
              userDetails: JSON.stringify({})
            },
            '*'
          );
        } catch {
          console.warn('Cannot set details in localstorage.');
        }
      }
    }
  }, 0);
};

export const getUserDetails = (formData: any) => {
  if (localStorage && typeof localStorage === 'object') {
    try {
      const storedUserDetails = JSON.parse(
        localStorage.getItem('bookingUserDetails')
      );
      const { company } = useCompanyStore();

      if (
        storedUserDetails?.companyId &&
        storedUserDetails.companyId === company.id
      ) {
        Object.keys(formData).forEach((key) => {
          if (storedUserDetails[key]) {
            return (formData[key] = storedUserDetails[key]);
          }
        });
      }
    } catch {
      console.warn('Cannot get details from localstorage.');
    }
  }
};
